// extracted by mini-css-extract-plugin
module.exports = {"likeButtonGroupSPHiddenMessage":"like-button-group-sp-hidden-message_likeButtonGroupSPHiddenMessage__esJkg"};